import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `Circular Std, sans-serif`,
    body: `Circular Std, sans-serif`,
  },
});

export default theme;
